var _path, _path2, _path3, _g, _path4, _path5, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 15H43L45 18L39.423 22L34.5 15Z",
    fill: "#534CEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.826 13.777C7.32 14.205 6.135 15.461 5.732 17.06C5 19.956 5 26 5 26C5 26 5 32.045 5.732 34.94C6.135 36.538 7.32 37.796 8.826 38.223C11.554 39 22.5 39 22.5 39C22.5 39 33.446 39 36.174 38.223C37.68 37.796 38.865 36.538 39.268 34.94C40 32.045 40 26 40 26C40 26 40 19.958 39.269 17.062C39.269 17.061 39.269 17.06 39.27 17.06C39.271 17.06 39.271 17.06 39.271 17.059C38.867 15.46 37.683 14.204 36.176 13.777C33.446 13 22.5 13 22.5 13C22.5 13 11.554 13 8.826 13.777ZM18.999 26C18.999 23.562 21.67 22.066 23.749 23.339C25.736 24.557 25.736 27.443 23.749 28.661C23.228 28.98 22.67 29.125 22.126 29.125C20.499 29.125 18.999 27.827 18.999 26Z",
    fill: "url(#paint0_linear_17411_9371)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_17411_9371",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H48V48H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_17411_9371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.355 25.8808C28.658 26.0778 28.658 26.5218 28.355 26.7188L19.773 32.2978C19.44 32.5138 19 32.2758 19 31.8788V20.7208C19 20.3248 19.44 20.0858 19.773 20.3018L28.355 25.8808Z",
    fill: "white"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25 6C24.448 6 24 6.448 24 7V17C24 17.552 24.448 18 25 18H45V7C45 6.448 44.553 6 44 6H25Z",
    fill: "url(#paint1_linear_17411_9371)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_17411_9371",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H48V48H0V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_17411_9371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.5962 14.7V9.39695H42.2652V10.415H39.8412V11.536H42.0752V12.554H39.8412V13.682H42.2732V14.7H38.5962ZM34.1422 9.39695L35.3502 13.308H35.3942L36.6032 9.39695H37.9942L36.2002 14.7H34.5452L32.7432 9.39695H34.1422ZM32.1492 14.7H30.9042V9.39695H32.1492V14.7ZM26.7432 14.7V9.39695H27.9882V13.682H30.2142V14.7H26.7432Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17411_9371",
    x1: 22.5,
    y1: 13,
    x2: 22.5,
    y2: 39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F16BF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E47EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_17411_9371",
    x1: 34.5,
    y1: 6.00001,
    x2: 34.5,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2F3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C95FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/이벤트.7efbcdbb8f61957738bd8b3a61d7682f.svg";
export { ForwardRef as ReactComponent };